var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "post rating-facebook",
      class: { "response-comment": _vm.responseComment },
    },
    [
      _c(
        "div",
        { staticClass: "detail-event-header" },
        [
          _c("AvatarComponent", {
            attrs: {
              typeNetwork: _vm.page.network,
              urlPicture: _vm.page.avatar,
            },
          }),
          _c("div", { staticClass: "info" }, [
            _c("div", { staticClass: "namePage" }, [
              _vm._v(
                "\n             " + _vm._s(_vm.page.name) + "\n            "
              ),
            ]),
            _c("div", { staticClass: "typeEvent" }, [
              _c("p", { attrs: { html: "" } }, [
                _vm._v(_vm._s(_vm.dateFormatPost(_vm.event.date * 1000))),
              ]),
            ]),
          ]),
          _c(
            "div",
            { staticClass: "selectActionEvent" },
            [
              _c("SelectComponent", {
                attrs: {
                  changeValueSelect: _vm.changeStatus,
                  data: {
                    treated: _vm.$t("dash.inbox.state.treated"),
                    waiting: _vm.$t("dash.inbox.state.waiting"),
                  },
                  valueSelect: [1, 3].includes(_vm.event.status)
                    ? "treated"
                    : "waiting",
                  positionY: "bottom",
                  positionAuto: false,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("div", { staticClass: "scrollable" }, [
        !_vm.isLoading
          ? _c("div", { staticClass: "container-content-comments" }, [
              _c("div", { staticClass: "container-comment" }, [
                _c(
                  "div",
                  {
                    staticClass: "comment",
                    class: { "has-response": false, hidden: false },
                  },
                  [
                    _c("div", { staticClass: "picture-user" }, [
                      _c("img", {
                        attrs: { src: _vm.event.user.picture.data.url },
                      }),
                      _c("div", { staticClass: "lineStart" }),
                    ]),
                    _c("div", { staticClass: "container-content" }, [
                      _c("div", { staticClass: "content" }, [
                        _c("p", { staticClass: "name-user" }, [
                          _vm._v(
                            _vm._s(_vm.event.data.changes.value.reviewer_name)
                          ),
                        ]),
                        _c(
                          "p",
                          { staticClass: "text" },
                          [
                            _vm.event.data.changes.value.recommendation_type
                              ? [
                                  _c("span", { staticClass: "ratting-type" }, [
                                    _vm._v(
                                      "Avis " +
                                        _vm._s(
                                          _vm.$t(
                                            "dash.inbox.rating.recommendation_type." +
                                              _vm.event.data.changes.value.recommendation_type.toLowerCase()
                                          )
                                        ) +
                                        " : "
                                    ),
                                  ]),
                                ]
                              : _vm._e(),
                            _vm._v(
                              "\n                                    \n                                    " +
                                _vm._s(
                                  _vm.event.data.changes.value.review_text
                                ) +
                                "\n                                "
                            ),
                          ],
                          2
                        ),
                      ]),
                      _c("div", { staticClass: "info-content" }, [
                        _c("div", { staticClass: "date" }, [
                          _vm._v(
                            _vm._s(
                              _vm.dateFormat(
                                _vm.event.data.changes.value.created_time
                              )
                            )
                          ),
                        ]),
                        _c("div", { staticClass: "action" }, [
                          _c(
                            "div",
                            {
                              staticClass: "answer",
                              on: {
                                click: function ($event) {
                                  return _vm.startResponseComment(
                                    _vm.event.data.changes.value.reviewer_id
                                  )
                                },
                              },
                            },
                            [_vm._v("Répondre")]
                          ),
                        ]),
                      ]),
                    ]),
                  ]
                ),
              ]),
            ])
          : _c(
              "div",
              { staticClass: "container-content-comments loading-content" },
              [
                _c("div", { staticClass: "container-comment" }, [
                  _c("div", { staticClass: "comment" }, [
                    _vm._m(0),
                    _c("div", { staticClass: "container-content" }, [
                      _c("div", { staticClass: "content" }, [
                        _c("p", { staticClass: "name-user" }, [_vm._v("www")]),
                        _c("p", { staticClass: "text" }, [
                          _vm._v(_vm._s("w".repeat(15 + Math.random() * 15))),
                        ]),
                      ]),
                      _vm._m(1),
                    ]),
                  ]),
                ]),
              ]
            ),
      ]),
      _c("FormSendMessage", {
        attrs: { activeMedia: false },
        on: { onSubmitMessage: _vm.sendComment },
      }),
      _vm.responseComment
        ? _c("div", { staticClass: "container-response-comment" }, [
            _c("p", [
              _vm._v("Répondre à "),
              _c("span", [
                _vm._v(_vm._s(_vm.event.data.changes.value.reviewer_name)),
              ]),
            ]),
            _c("i", {
              staticClass: "fa-solid fa-circle-xmark",
              on: { click: _vm.stopResponseComment },
            }),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "picture-user" }, [
      _c("img", {
        attrs: {
          src: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAAJElEQVRoge3BAQEAAAjDoPUvfYMItG0BAAAAALwHAAAAwC/VAZFoA/0E7YaAAAAAAElFTkSuQmCC",
        },
      }),
      _c("div", { staticClass: "lineStart" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "info-content" }, [
      _c("div", { staticClass: "action" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }